
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"a",attrs:{"cx":"3.75","cy":"20.25","r":"3"}}),_c('path',{staticClass:"a",attrs:{"d":"M.75 20.25V3.75a3 3 0 016 0v16.5"}}),_c('path',{staticClass:"a",attrs:{"d":"M3.75 23.25h18a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5h-15"}}),_c('path',{staticClass:"a",attrs:{"d":"M18 12.25V18h-6v-5.75"}}),_c('path',{staticClass:"a",attrs:{"d":"M10.5 13.5L15 9.75l4.5 3.75"}})])
          )
        }
      }
    